var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0.707107,
    width: 11,
    height: 11,
    rx: 1.5,
    transform: "rotate(45 8 0.707107)",
    stroke: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon);
export default __webpack_public_path__ + "static/media/feature-icon.577da208978ff3e2f13b251e629d9c5f.svg";
export { ForwardRef as ReactComponent };